var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "50,5 5,50 50,95 95,50",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "50,5, 5,50 50,50",
  fill: "#002147"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "50,20 50,30 75,30 65,20",
  fill: "#BB133E"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "50,40 50,50 95,50 85,40",
  fill: "#BB133E"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "15,60 25,70 75,70 85,60",
  fill: "#BB133E"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "35,80 45,90 55,90 65,80",
  fill: "#BB133E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "star",
  d: " M 45.000 46.000 L 46.176 46.618 L 45.951 45.309 L 46.902 44.382 L 45.588 44.191 L 45.000 43.000 L 44.412 44.191 L 43.098 44.382 L 44.049 45.309 L 43.824 46.618 L 45.000 46.000 ",
  fill: "white",
  transform: "translate(-1, -1)"
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(-20, 0)"
});

var _ref10 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(-15, -5)"
});

var _ref11 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(-10, -10)"
});

var _ref12 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(-10, 0)"
});

var _ref13 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(-5, -15)"
});

var _ref14 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(-5, -5)"
});

var _ref15 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(0, -20)"
});

var _ref16 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#star",
  transform: "translate(0, -10)"
});

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.e364b974150307d31fe6421978b785a0.svg";
export { ForwardRef as ReactComponent };